/**
 * Unified Governance hub at `/admin` — Phase 1 of the RBAC UX refactor.
 *
 * Why a separate plugin instead of extending `page:rbac`:
 *   The community RBAC plugin does not export its internal route components,
 *   so a true tabbed merge requires either vendoring the plugin (fork) or
 *   building a companion shell that consumes `rbacApiRef`. This module is
 *   the shell; Roles tab links to `/rbac` for the full editor until the
 *   fork lands in `packages/plugins/`.
 *
 * Legacy routes `/rbac`, `/permissions-guide`, and `/notifications-admin`
 * remain for deep links; sidebar consolidates to a single Governance entry.
 */
import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import SecurityIcon from '@material-ui/icons/Security';

const governanceRouteRef = createRouteRef();

const governancePage = PageBlueprint.make({
  params: {
    path: '/admin',
    title: 'Governance',
    icon: <SecurityIcon />,
    routeRef: governanceRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/governance/GovernanceAdminPage').then(m => (
        <m.GovernanceAdminPage />
      )),
  },
});

export const governanceModule = createFrontendPlugin({
  pluginId: 'governance',
  routes: {
    governance: governanceRouteRef,
  },
  extensions: [governancePage],
});
